@import 'styles/variables';
@import 'styles/mixins';

@keyframes spin {
  100% {
    transform: rotate(-360deg);
  }
}

.svg {
  position: absolute;
  z-index: 1;
  left: -474px;
  top: -485px;
  animation: spin 60000ms linear infinite;
  opacity: 0.5;

  @media (max-width: $phoneMaxWidth) {
    left: -610px;
    top: -650px;
  }
}

.center {
  width: 340px;
  height: 340px;
  border-radius: 50%;
  position: absolute;
  background: var(--blaze-beige);
  left: 100px;
  top: 175px;
  z-index: 2;
  filter: blur(6px);

  &.centered {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  @media (max-width: $phoneMaxWidth) {
    display: none;
  }
}

.container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  &.centered {
    padding: 64px 0 128px 0;
  }
}

@property --offset-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@keyframes spin-bg {
  from {
    --offset-angle: 0deg;
  }
  to {
    --offset-angle: 4deg;
  }
}
.spinner {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: radial-gradient(white, transparent);
  overflow: hidden; /* Ensure the pseudo-element doesn't leak outside the spinner */
  @media (max-width: $phoneMaxWidth) {
    height: auto;
  }

  &:before {
    content: '';
    position: absolute;
    background: repeating-conic-gradient(
      var(--ray-color) var(--offset-angle) calc(var(--offset-angle) + 2deg),
      white calc(var(--offset-angle) + 2deg) calc(var(--offset-angle) + 4deg)
    );
    animation: spin-bg 0.6s linear infinite;
    z-index: 1;
    width: 200%;
    height: 200%;
    left: calc(-50% - 182px);
    top: -50%;
    opacity: 0.5;

    @media (max-width: $phoneMaxWidth) {
      left: -50%;
      top: -50%;
    }
  }

  &.centered::before {
    left: -50%;
  }
}
